import { Modal } from "../Modal/Modal.tsx";
import { SuperZoomImage } from "./SuperZoomImage.tsx";
import { GalleryObject, ImageClickPosition } from "../utils/utils.ts";

export interface SuperZoomModalProps {
  isOpen: boolean;
  mediaItems: GalleryObject[];
  selectedIndex: number;
  imageClickPosition: ImageClickPosition;
  onClose: () => void;
}

export const SuperZoomModal = ({
  isOpen,
  mediaItems,
  selectedIndex,
  imageClickPosition,
  onClose,
}: SuperZoomModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} enableBodyScrollOverride={false}>
      <SuperZoomImage
        mediaItems={mediaItems}
        selectedIndex={selectedIndex}
        imageClickPosition={imageClickPosition}
        onClose={onClose}
      />
    </Modal>
  );
};
